<script>
import { formRenderMixin } from '@/mixins/formRender';

import AppealDate from './actionData/AppealDate';
import Archive from './actionData/Archive';
import BeforeDocumentCreate from './actionData/BeforeDocumentCreate';
import BiK from './actionData/BiK';
import Certificate from './actionData/Certificate';
import Comment from './actionData/Comment';
import Confirm from './actionData/Confirm';
import ConfirmForm from './actionData/ConfirmForm';
import ConfirmMdokSubmit from './actionData/ConfirmMdokSubmit';
import ConfirmRecruitmentClose from './actionData/ConfirmRecruitmentClose';
import DateInput from './actionData/DateInput';
import DateRangeStart from './actionData/DateRangeStart';
import DecisionEnd from './actionData/DecisionEnd';
import DecisionStart from './actionData/DecisionStart';
import DeliveryDate from './actionData/DeliveryDate';
import DeliveryDateExtended from './actionData/DeliveryDateExtended';
import DeliveryDateWithEpuap from './actionData/DeliveryDateWithEpuap';
import Diploma from './actionData/Diploma';
import DuplicatesDocuments from './actionData/DuplicatesDocuments';
import FileTransfer from './actionData/FileTransfer';
import FileTransfer004 from './actionData/FileTransfer004';
import GeneralContent from './actionData/GeneralContent';
import GeneralDeed from './actionData/GeneralDeed';
import Invitation from './actionData/Invitation';
import Judgment from './actionData/Judgment';
import KoReport from './actionData/KoReport';
import ListOfSko from './actionData/ListOfSko';
import Mdok from './actionData/Mdok';
import NoForm from './actionData/NoForm';
import PreventDecision from './actionData/PreventDecision';
import PrezydenckiData from './actionData/PrezydenckiData';
import Reason from './actionData/Reason';
import ReplyFormSelect from './actionData/ReplyFormSelect';
import ScholarshipCurrentPayoutMultiple from './actionData/ScholarshipCurrentPayoutMultiple';
import ScholarshipCurrentPayoutSingle from './actionData/ScholarshipCurrentPayoutSingle';
import ScholarshipStudentList from './actionData/ScholarshipStudentList';
import SchoolSubmitEPUAP from './actionData/SchoolSubmitEPUAP';
import SetValues from './actionData/SetValues';
import SubmitEPUAP from './actionData/SubmitEPUAP';
import SubmitManually from './actionData/SubmitManually';
import SubmitSigned from './actionData/SubmitSigned';
import Address from './filters/Address';
import CheckboxList from './filters/CheckboxList';
import ExcludeRadio from './filters/ExcludeRadio';
import NumberRange from './filters/NumberRange';
import Radio from './filters/Radio';
import SchoolPicker from './filters/SchoolPicker';
import SchoolPickerCombined from './filters/SchoolPickerCombined.vue';
import TextInput from './filters/TextInput';

// @vuese
// Renderer formularza danych akcji
export default {
  components: {
    Address,
    AppealDate,
    Archive,
    BeforeDocumentCreate,
    BeforeDuplicatesDocumentCreate: BeforeDocumentCreate,
    BeforeOw004DocumentCreate: BeforeDocumentCreate,
    BoolRadio: Radio,
    BiK,
    CheckboxList,
    Certificate,
    Comment,
    ConfirmForm,
    ConfirmMdokSubmit,
    ConfirmPack: Confirm,
    ConfirmRecruitmentClose,
    ConfirmRemoveAnnounecment: Confirm,
    ConfirmRemoveDocument: Confirm,
    DateInput,
    DecisionStart,
    DecisionHoldEnd: DecisionEnd,
    DecisionHoldOrWithdrawalEnd: DecisionEnd,
    DecisionWithdrawalEnd: DecisionEnd,
    DeliveryDate,
    DeliveryDateExtended,
    DeliveryDateWithEpuap,
    Diploma,
    DuplicatesCallForReplenishment: DuplicatesDocuments,
    DuplicatesEmptyDoc: DuplicatesDocuments,
    DuplicatesPreparationRefusal: DuplicatesDocuments,
    DuplicatesReceiptOfTheLetter: DuplicatesDocuments,
    ExcludeBooleanRadio: ExcludeRadio,
    ExcludeRadio,
    ExistRadio: Radio,
    FileTransfer,
    FileTransfer004,
    GeneralContent,
    GeneralDeed,
    Invitation,
    Judgment,
    KoReport,
    Mdok,
    NoForm,
    NumberRange,
    OW004ListOfSko: ListOfSko,
    PreventDecision,
    PrezydenckiData,
    Radio,
    Reason,
    ReplyFormSelect,
    SchoolPicker,
    SchoolPickerCombined,
    SchoolSubmitEPUAP,
    SendToFix: Comment,
    SubmitEPUAP,
    SubmitSigned,
    SubmitSignedPrezydencki: SubmitSigned,
    SubmitManually,
    SubmitManuallyAnnouncement: SubmitManually,
    SubmitManuallyConfirm: SubmitManually,
    SubmitManuallyDuplicates: SubmitManually,
    SuspensionDateSubmit: DateRangeStart,
    TextInput,
    WithdrawalDateSubmit: DateRangeStart,

    ScholarshipCurrentPayoutMultiple,
    ScholarshipCurrentPayoutSingle,
    ScholarshipPayoutDateSingle: ScholarshipCurrentPayoutSingle,
    ScholarshipPayoutDateMultiple: ScholarshipCurrentPayoutMultiple,
    ScholarshipStudentList,

    DuplicatesReadyToHandling: SetValues
  },
  mixins: [formRenderMixin]
};
</script>
